
import {
  computed,
  defineComponent,
  nextTick,
  ref,
  toRef,
  watch,
  onMounted,
} from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
// import { LookupAPI } from "@/services/api/Lookup.service";
import { UserAPI } from "@/services/api/User.service";
import * as Yup from "yup";
import { hideModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
// import { ICloneLookup } from "@/interfaces/iLookup";
import { useI18n } from "vue-i18n/index";
// import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
// import moment from "moment-timezone";
import { hasPermission } from "@/core/services/permission.service";
import { getCurrentUser } from "@/core/services/JwtService";
export default defineComponent({
  name: "user-clone-modal",
  emit: ["clone-submit"],
  props: {
    role: { type: Object, default: null },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    // Datepicker,
  },
  setup(props, { emit }) {
    const { t, te } = useI18n();
    function translate(key: string) {
      if (te(key)) {
        return t(key);
      } else {
        return key.split(".").join(" ");
      }
    }
    const toast = useToast();
    const cloneSuccessMsg = translate("pages.user.roleCloneMessage");
    const newTargetCloneModalRef = ref<null | HTMLElement>(null);
    const cloneLookupRef = ref<null | HTMLFormElement>(null);
    const loading = ref(false);
    let roles = ref<any>([]);
    let rolePermissions = ref<any>([]);
    let permissionGroups = ref<any>([]);
    let permissionGroupsFilter = ref<any>([]);
    let permissionGroupsCollpased = ref<any>([]);
    let roleObj = ref<any>({});
    const selectedRole = ref<any>({});
    const cloneData = toRef(props, "role");
    let cloneTargetData = ref<any>({});
    // let arrayModuleNameList = ref<any>([]);
    let cloneRoleData = ref({
      validationSchema: Yup.object({
        roleName: Yup.string()
          .max(30, getMaxLengthErrorMessage(t("common.name"), 30))
          .required(t("common.name") + " " + t("common.isRequired"))
          .label(t("common.name")),
      }),
    });
    roleObj.value = computed(() => {
      return props.role;
    }).value;
    const discard = () => {
      var appElement = document.getElementById("app");
      if (appElement) {
        appElement.click();
      }
      hideModal(newTargetCloneModalRef.value);
      nextTick(() => {
        cloneLookupRef?.value?.resetForm();
      });
      emit("on-cancel", null);
    };
    const format = computed(() => {
      return FormatMethods;
    });
    const getUserRoles = async (params?: Record<string, number | string>) => {
      await UserAPI.getInstance()
        .getRolesWithUserCount({
          ...params,
        })
        .then((data: any) => {
          roles.value = [];
          data.content.map((obj) => {
            roles.value.push({
              label: obj.roleName,
              value: obj.webId,
              userCount: obj.count,
            });
          });
        });
    };

    const setLookupCloneData = async () => {
      try {
        permissionGroupsCollpased.value = [];
        await UserAPI.getInstance()
          .getPermissionGroups()
          .then((res) => {
            permissionGroups.value = [...res];
            permissionGroupsFilter.value = [...res];
            let i = 1;
            permissionGroupsCollpased.value.push(true);
            while (permissionGroupsFilter.value.length > i) {
              permissionGroupsCollpased.value.push(false);
              i = i + 1;
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            //
          });
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };
    const toggleCollapse = (index) => {
      // Toggle the boolean value at the specified index
      permissionGroupsCollpased.value[index] =
        !permissionGroupsCollpased.value[index];
    };
    const checkPermission = (webId: any) => {
      return (
        roles?.value
          ?.filter(
            (role: { value: any }) => role.value == selectedRole.value.value
          )[0]
          ?.permissions?.filter(
            (perms: { permissionId: any }) => perms.permissionId == webId
          ).length > 0
      );
    };
    const getSpecificPermissionFromList = (list, id) => {
      return list.filter((perm) => perm.permissionCode.includes(id))[0]?.webId;
    };
    const getRolePermissionWebId = (permissionId) => {
      return roles?.value
        ?.filter(
          (role: { value: any }) => role.value == selectedRole.value.value
        )[0]
        ?.permissions?.filter(
          (perms: { permissionId: any }) => perms.permissionId == permissionId
        )[0].webId;
    };
    const submitCloneData = async () => {
      try {
        loading.value = true;

        const permissions = selectedRole?.value.permissions || [];

        // Extract permissionIds and titles
        const permissionIdsArray = permissions.map((permission) => ({
          permissionId: permission.permissionId,
        }));

        const permissionTitles = permissions.map(
          (permission) => permission.title
        );

        /** DEFINE KEYWORDS WITH THEIR ASSOCIATED MODULE CODES */
        const keywordGroups = [
          {
            permissionCode: "Applications",
            keywords: ["Sms", "Scheduler", "Email", "Task"],
          },
          {
            permissionCode: "Business",
            keywords: ["Client", "Sites", "Locations"],
          },
          {
            permissionCode: "Dashboard",
            keywords: [
              "User Statistics",
              "Performance Review",
              "Sites Overview",
            ],
          },
          {
            permissionCode: "Integrations",
            keywords: ["Email Manager", "Devices"],
          },
          {
            permissionCode: "Settings",
            keywords: ["Lookup Configuration", "Events"],
          },
          {
            permissionCode: "Templates",
            keywords: ["Forms", "Section", "Tasks"],
          },
          {
            permissionCode: "Users",
            keywords: ["Users", "Roles", "Permissions", "User Permissions"],
          },
        ];

        /** FUNCTION TO CHECK IF ANY KEYWORD EXISTS IN PERMISSION TITLES */
        const hasKeywords = (keywords) =>
          permissionTitles.some((title) =>
            keywords.some((keyword) => title.includes(keyword))
          );

        /** GENERATE TOGGLE PERMISSION MODEL BASED ON KEYWORD PRESENCE */
        const togglePermissionModel = keywordGroups.map((group) => ({
          permissionCode: group.permissionCode,
          toggle: hasKeywords(group.keywords),
        }));
        const payload = {
          roleModel: {
            roleName: cloneTargetData.value.roleName,
            status: "ACTIVE",
          },
          rolePermissionModel: permissionIdsArray,
          togglePermissionModel: togglePermissionModel,
        };

        await UserAPI.getInstance().submitCloneRole(payload);
        toast.success(cloneSuccessMsg);
        discard();
        emit("clone-submit");
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };

    const clearFormData = () => {
      cloneLookupRef?.value?.resetForm();
      cloneTargetData.value = {};
    };
    const updatePermissionForRole = async (permissionId, checked?) => {
      try {
        loading.value = true;
        if (checkPermission(permissionId)) {
          const index = rolePermissions.value.findIndex(
            (prem) => prem.webId == getRolePermissionWebId(permissionId)
          );
          if (index > -1) {
            rolePermissions.value.splice(index, 1);
          }
          const roleIndex = roles.value.findIndex(
            (role) => role.value == selectedRole.value.value
          );
          const rolePermissionIndex =
            roles?.value[roleIndex].permissions?.findIndex(
              (perms: { permissionId: any }) =>
                perms.permissionId == permissionId
            ) ?? -1;
          if (rolePermissionIndex > -1) {
            roles.value[roleIndex].permissions.splice(rolePermissionIndex, 1);
            selectedRole.value.permissions.splice(rolePermissionIndex, 1);
          }
        } else {
          const foundPermission = rolePermissions.value.find(
            (permission) => permission.permissionId === permissionId
          );

          selectedRole.value.permissions.push(foundPermission);
        }
      } catch (error) {
        // getUserRoles();
      } finally {
        loading.value = false;
      }
    };
    const getRolePermissions = async () => {
      rolePermissions.value = [];
      await UserAPI.getInstance()
        .getRolePermissions()
        .then((res) => {
          rolePermissions.value = [...res];
          roles?.value?.forEach((role: { permissions: any; value: any }) => {
            role.permissions = [];
            role.permissions = rolePermissions.value.filter(
              (rolePer: { roleId: any }) => rolePer.roleId == role.value
            );
          });
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const currentUser = computed(() => {
      return getCurrentUser();
    });

    watch(
      cloneData,
      async (newValue) => {
        // checkedToggleButton()
        const clonedValue = JSON.parse(JSON.stringify(newValue)); // Create a deep copy
        roleObj.value = clonedValue;
        // await checkedToggleButton(roleObj.value.value);
        clearFormData();
        selectedRole.value = clonedValue; // Assign the deep copy to selectedRole
        getUserRoles()
          .then(() => {
            setLookupCloneData();
          })
          .catch((err) => {
            console.error(err);
          });
        getRolePermissions();
      },
      { immediate: true }
    );

    return {
      translate,
      setLookupCloneData,
      submitCloneData,
      cloneTargetData,
      newTargetCloneModalRef,
      format,
      cloneLookupRef,
      discard,
      roleObj,
      loading,
      permissionGroups,
      permissionGroupsFilter,
      permissionGroupsCollpased,
      cloneRoleData,
      checkPermission,
      hasPermission,
      getSpecificPermissionFromList,
      updatePermissionForRole,
      toggleCollapse,
    };
  },
});
